import { Modal } from 'react-bootstrap';
import React, { Component } from 'react';
import classNames from 'classnames/bind';
import styles from './PreviewConfigurationModal.css';
import TabletPreview from './TabletPreview';
import SmartphonePreview from './SmartphonePreview';

class PreviewConfigurationModal extends Component {
  state = { isFirstTabSelected: true };

  render() {
    const { isShowing, onClose, selectedPaymentMethods } = this.props;
    const { isFirstTabSelected } = this.state;

    return (
      <Modal show={isShowing} dialogClassName={styles.dialog}>
        <Modal.Header className={styles.header}>
          <Modal.Title className={styles.title}>
            Preview Configuration
          </Modal.Title>

          <div className={styles.tabParent}>
            <div
              className={classNames(styles.tab, {
                [styles.tabActive]: isFirstTabSelected,
              })}
              onClick={() => this.setState({ isFirstTabSelected: true })}
            >
              Tablet
            </div>
            <div
              className={classNames(styles.tab, {
                [styles.tabActive]: !isFirstTabSelected,
              })}
              onClick={() => this.setState({ isFirstTabSelected: false })}
            >
              Smartphone
            </div>
          </div>
        </Modal.Header>
        <Modal.Body className={styles.body}>
          <div className={styles.previewContainer}>
            {isFirstTabSelected ? (
              <TabletPreview selectedPaymentMethods={selectedPaymentMethods} />
            ) : (
              <SmartphonePreview
                selectedPaymentMethods={selectedPaymentMethods}
              />
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-default" onClick={onClose}>
            Close
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default PreviewConfigurationModal;
